import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { CLUBS } from "../../data/clubs";
import { useClubRoomsOn } from "../../hooks/useClubRoomsOn";

// The tenant club rooms: each club gets its own room, mostly MTTs built to their order.
// Six slots in the space the player's wallet used to take — three live clubs, three still to be signed.
export { CLUBS };

export const ClubRooms = () => {
  const nav = useNavigate();
  const on = useClubRoomsOn() || [];
  const shown = CLUBS.filter((c) => on.includes(c.slug));   // demo mode: only rooms switched on in admin show
  return (
    <div className="flex flex-col gap-3" data-testid="lobby-club-rooms">
      <div className="text-[11px] uppercase tracking-[0.3em] gold-text px-1">Club rooms</div>
      {shown.map((c, i) => (
        <button key={c.slug} data-testid={`club-room-${c.slug}`} onClick={() => nav(`/${c.slug}`)}
          title={`${c.name} — their own room`} style={{ animationDelay: `${i * 70}ms` }}
          className="gold-card rise rounded-2xl p-3 h-[88px] flex items-center justify-center hover:border-amber-400/80 btn-lift transition-colors">
          <span className={`w-full h-full rounded-xl flex items-center justify-center ${c.tileFit === "cover" ? "px-1 py-0.5" : "px-4 py-2"}`}
            style={c.tileBg ? { background: c.tileBg, border: "1px solid rgba(255,255,255,0.10)" } : { background: "rgba(255,255,255,0.95)" }}>
            <img src={c.tileLogo || c.tile} alt={c.name} className={`object-contain ${c.tileFit === "cover" ? "h-full w-auto max-w-full" : "max-h-full max-w-full"}`} />
          </span>
        </button>
      ))}
      {Array.from({ length: Math.max(0, 6 - shown.length) }, (_, n) => n).map((n) => (
        <div key={n} data-testid={`club-room-soon-${n}`} style={{ animationDelay: `${(n + shown.length) * 70}ms` }}
          className="gold-card rise rounded-2xl p-3 h-[88px] flex flex-col items-center justify-center gap-1 border-dashed opacity-70">
          <Lock className="w-4 h-4 text-amber-300/70" />
          <span className="text-[11px] uppercase tracking-[0.3em] text-slate-400">Coming soon</span>
        </div>
      ))}
    </div>
  );
};
